import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { message } from 'antd';
import MuiButton from 'material-ui/Button';
import localForage from 'localforage';

import BizCard from '../../components/UI/BizCard';
import BizInput from '../../components/UI/BizInput';
import S3Upload from '../../components/S3Upload';
import FormFloatingButtons from '../../components/FormFloatingButtons';

import MUTATION from '../../graphql/mutations/lcsFisMutation.graphql';

import { removeTypenameFromArrays } from '../../utils/globals';

const localForageItemkey = (cid) => (`${cid}_lcsFis`);

const initialState = ({ queries }) => ({
  startedAt: new Date().toISOString(),
  queries: removeTypenameFromArrays(queries.map((entry) => ({ ...entry, reply: '' }))),
});

class LcsFisForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState(props.lcsFis),
    };
  }

  componentDidMount() {
    localForage.getItem(localForageItemkey(this.props.match.params.cid))
      .then((value) => {
        if (value) {
          this.setState({
            ...value,
          });
        }
      });
  }

  clearForm = () => {
    localForage.removeItem(localForageItemkey(this.props.match.params.cid));
    this.setState({
      ...initialState(this.props.lcsFis),
    });
  };

  saveData = () => {
    const { ...data } = this.state;
    localForage.setItem(localForageItemkey(this.props.match.params.cid), data)
      .then(() => {
        message.success('Saved!');
      })
      .catch(() => {
        message.error('Not Saved!');
      });
  };

  handleArrayFormValue = (arrayName, id, key, value) => {
    this.setState({
      [arrayName]: this.state[arrayName].map((entry) => {
        if (entry.id === id) {
          return { ...entry, [key]: value };
        }
        return entry;
      }),
    });
  };

  handleFormSubmit = () => {
    const customerId = this.props.match.params.cid;

    this.props.mutate({
      variables: {
        customerId,
        ...this.state,
      },
    })
      .then(() => {
        message.success('Success!');
        this.clearForm();
        this.props.history.push(`/app/lead/${customerId}/lcs`);
      })
      .catch((mutateErr) => {
        message.error(mutateErr.message);
      });
  };

  render() {
    const {
      queries,
    } = this.state;

    const { docs } = this.props;
    const { docsIds } = this.props.lcsFis;

    return (
      <BizCard title="Further Information Sheet">
        <FormFloatingButtons handleSave={this.saveData} handleClear={this.clearForm} />
        <table className="biz-form-table">
          <tbody>
            {/* Queries */}
            {
              queries && queries.length > 0 ?
                <tr>
                  <td className="biz-form-table-label">Queries</td>
                  <td className="biz-form-table-input">
                    <table className="biz-data-table biz-bordered">
                      <thead>
                        <tr>
                          <th>Query</th>
                          <th>Reply</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          queries.map((entry) => (
                            <tr key={entry.id}>
                              <td>{entry.query}</td>
                              <td>
                                <BizInput
                                  type="textarea"
                                  textareaRows={2}
                                  theme="lac"
                                  name={`queries[${entry.id}][reply]`}
                                  onChange={(value) => { this.handleArrayFormValue('queries', entry.id, 'reply', value); }}
                                  value={entry.reply}
                                />
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                  </td>
                  <td className="biz-form-table-action" />
                </tr>
                :
                null
            }

            {/* Documents to be uploaded */}
            {
              docsIds.length > 0 ?
                <tr>
                  <td className="biz-form-table-label">Documents to be uploaded</td>
                  <td className="biz-form-table-input">
                    <table className="biz-data-table biz-bordered">
                      <tbody>
                        {
                          docsIds.map((entry) => {
                            const doc = docs.find((element) => (element.id === entry));
                            if (doc) {
                              return (
                                <tr key={entry}>
                                  <td>{doc.title}</td>
                                  <td>
                                    <S3Upload s3Key={doc.title} fileName={doc.title} />
                                  </td>
                                </tr>
                              );
                            }
                            return null;
                          })
                        }
                      </tbody>
                    </table>
                  </td>
                </tr>
                :
                null
            }

            <tr>
              <td className="biz-form-table-label" />
              <td colSpan={2}>
                <MuiButton variant="raised" color="primary" style={{ margin: '5px 0' }} onClick={this.handleFormSubmit}>
                  Submit
                </MuiButton>
              </td>
            </tr>
          </tbody>
        </table>
      </BizCard>
    );
  }
}

LcsFisForm.propTypes = {
  lcsFis: PropTypes.shape({
    id: PropTypes.number.isRequired,
    docsIds: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  docs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
  })).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      cid: PropTypes.string.isRequired,
    }),
  }).isRequired,
  mutate: PropTypes.func.isRequired,
};

export default graphql(MUTATION)(LcsFisForm);



// WEBPACK FOOTER //
// ./src/pages/leads/LcsFisForm.jsx